export enum Template {
    NEWSLETTER = 'NEWSLETTER'
}
